import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'sign-in-forgot-password',
  templateUrl: './sign-in-forgot-password.component.html',
  styleUrls: ['./sign-in-forgot-password.component.css']
})
export class SignInForgotPasswordComponent implements OnInit {

  constructor(
    public authService: AuthService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

}
